import * as $ from "jquery";
declare global {
	interface Window {
		dataLayer:any;
	}
}

function trackFAQ(faqText, eventType) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'clickText' : faqText, //Insert the text of the FAQ
		'event' : eventType
	});
}


function Accordion() {
	$('.js-acc-trigger').on('click', function(e){
		let $this = $(this),
			$parent = $this.parent('.accordion-list__item'),
			textContent = $this.text();

		$parent.toggleClass('state-open');
		e.preventDefault();

		if($this.parents('.state-open').length) {
			trackFAQ(textContent, 'faq_expanded');
		} else {
			trackFAQ(textContent, 'faq_collapsed');
		}
	});
}

export function init() {
	Accordion();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/accordion.ts